(function($) {
    
    $('.tooltip').tooltipster({
        distance: 0
     });

})(jQuery);